import React from "react";

const Divider = () => <hr class="Divider Divider--space" />;

export default Divider;
